import { defineStore } from "pinia";

export const useUsersStore = defineStore("user", {
  state: () => {
    return {
      theme: "Coo", // Snailax //Comfier //Cupilo //Coo
      // 关闭索评功能的品牌（可配置扩展）
      disabledReviewThemes: ["Snailax", "Cupilo", "COOCOCO"],
      defaultLang: "en", //系统默认语言
      isLogin: localStorage.getItem("token") ? true : false,
      userInfo: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {},
      account: "",
      userAddress: "",
      activationCode: "",
      apiKey: "",
      logisticsToken: localStorage.getItem("logisticsToken")
        ? localStorage.getItem("logisticsToken")
        : "",
    };
  },
  getters: {
    // 当前品牌是否开启索评（统一小写匹配）
    enableReview(state) {
      const theme = (state.theme || "").toLowerCase();
      return !state.disabledReviewThemes
        .map((t) => String(t).toLowerCase())
        .includes(theme);
    },
  },
});
